<template>
  <div class="tw:my-4">
    <PropertyImages :accommodation="accommodationBasicInfo" :images="images" />
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue'

import PropertyImages from '@/components/propertyDetails/propertyImages/PropertyImages.vue'

import { useAccommodationBasicInfo, useGetImages, useGetMainImage } from '@/components/propertyDetails/queries'
import { usePropertyImages } from '@/components/propertyDetails/propertyImages/usePropertyImages.ts'

const { resetDeleteItemIds } = usePropertyImages()

const { accommodationBasicInfo } = useAccommodationBasicInfo()
const { images } = useGetImages()
const { mainImage } = useGetMainImage()

/**
 * Reset deleting IDs when images are removed
 * Detects deletion by comparing array lengths
 */
watch(images, (newValue, oldValue) => {
  if (oldValue.length > newValue.length) {
    resetDeleteItemIds()
  }
})

/**
 * Preload main image when it changes
 * Creates cached Image object to improve loading performance
 */
watch(mainImage, newMainImage => {
  if (!newMainImage?.height || !newMainImage?.width || !newMainImage?.imagePath) return

  const mainImageCached = new Image()
  mainImageCached.src = `https://imgcy.trivago.com/c_limit,d_dummy.jpeg,f_auto,c_scale,h_${newMainImage.height},q_auto,w_${newMainImage.width}/${newMainImage.imagePath}`
})
</script>
